import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { toast } from 'sonner';
import { schools } from '../data/mockSchools';
import { PageHeader } from '../components/common/PageHeader';
export function Compare() {
  const [params] = useSearchParams();
  const ids = (params.get('ids') || '').split(',').filter(Boolean);
  const list = ids.length ? schools.filter(s => ids.includes(s.id)) : schools.slice(0, 3);
  const rows = [{
    k: '排名',
    f: (s: any) => `QS #${s.rank}`
  }, {
    k: '学费',
    f: () => '£35k/年'
  }, {
    k: '学制',
    f: () => '1-2 年'
  }, {
    k: '申请要求',
    f: () => 'GPA 3.5+\n雅思 7.0+'
  }, {
    k: '录取率',
    f: () => '12%'
  }, {
    k: '就业方向',
    f: () => 'IT / 金融 / 咨询'
  }];
  return <div className="min-h-screen bg-slate-50 pb-20" data-id="element-434">
      <PageHeader title="院校对比" data-id="element-435" />

      <div className="m-3 bg-white rounded-2xl overflow-hidden" data-id="element-436">
        <div className="overflow-x-auto" data-id="element-437">
          <table className="w-full text-sm" data-id="element-438">
            <thead data-id="element-439">
              <tr className="bg-blue-50 text-blue-700" data-id="element-440">
                <th className="p-3 text-left font-semibold w-20 sticky left-0 bg-blue-50" data-id="element-441">
                  维度
                </th>
                {list.map(s => <th key={s.id} className="p-3 text-center font-semibold min-w-[110px]" data-id="element-442">
                    <div className="text-xs" data-id="element-443">{s.cn}</div>
                    <div className="text-[10px] text-slate-500 font-normal mt-0.5" data-id="element-444">
                      {s.flag} {s.country}
                    </div>
                  </th>)}
              </tr>
            </thead>
            <tbody data-id="element-445">
              {rows.map(r => <tr key={r.k} className="border-t border-slate-100" data-id="element-446">
                  <td className="p-3 text-slate-500 font-medium sticky left-0 bg-white" data-id="element-447">
                    {r.k}
                  </td>
                  {list.map(s => <td key={s.id} className="p-3 text-center text-slate-800 whitespace-pre-line" data-id="element-448">
                      {r.f(s)}
                    </td>)}
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>

      <div className="px-3 flex gap-2" data-id="element-449">
        <button onClick={() => toast.success('对比图片已保存到相册')} className="flex-1 h-11 rounded-full border border-blue-500 text-blue-600 font-semibold text-sm" data-id="element-450">
          保存图片
        </button>
        <button onClick={() => toast.success('已生成分享海报')} className="flex-1 h-11 rounded-full bg-blue-600 text-white font-semibold text-sm" data-id="element-451">
          分享海报
        </button>
      </div>
    </div>;
}